import styled from 'styled-components';

const Content = styled.div`
  margin: 0 auto;
  width: 100%;
  max-width: 1300px;
  padding: 5px 10px;
  ${({ theme }) => theme.mq.xs} {
    padding: 5px 20px;
  }
  ${({ theme }) => theme.mq.md} {
    padding: 5px 30px;
  }
`;

export default Content;
